module.exports = __webpack_public_path__ + "img/1F621.13ee64b3.svg";